// removed by extract-text-webpack-plugin
module.exports = {"Confirm":"Confirm__Confirm__3Y8uW","OptionHolder":"Confirm__OptionHolder__3kRxs","ConfirmText":"Confirm__ConfirmText__1z-P7","ConfirmButton":"Confirm__ConfirmButton__3Iihr","DeclineButton":"Confirm__DeclineButton__1WiTK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/ButtonIconConfirm/Confirm/Confirm.css
// module id = 337
// module chunks = 0